<template>
  <!--悬浮框 支付定金提示中-->
  <div class="m-pop-layer">
    <div class="m-flex-row">
      <div class="m-pop-content" v-if="comdata.curType != 1">
        <div class="m-pop-title">
          <!--<p>确认预定信息</p>-->
        </div>
        <div class="m-pop-center">
          <div class="m-wait">
            <div class="spinner">
              <div class="bounce1"></div>
              <div class="bounce2"></div>
              <div class="bounce3"></div>
            </div>
            <!--<img src="../../assets/images/ic-wait.png"/>-->
          </div>
          <div style="color: rgba(0, 0, 0, 0.9)">正在等待支付结果</div>
        </div>
        <div class="m-pop-bottom">
          <div>
            <a class="m-btn m-btn-commit"
              >支付定金 ¥{{ comdata.amount / 100 }}</a
            >
          </div>
          <div class="m-tip" style="display: none"><a>已完成支付?</a></div>
        </div>
      </div>
      <div class="pay-dialog-body" v-if="comdata.curType == 1">
        <div class="pay-dialog-top">
          <div>收银台</div>
          <img
            @click="closeIframePay"
            src="https://img.izhaowo.com/wallet-pc/payment-dialog-close-img.png"
            alt=""
          />
        </div>
        <iframe
          style="width: 100%; height: calc(100vh - 66px)"
          :src="payUrl"
          frameborder="0"
        ></iframe>
      </div>
    </div>
    <!-- cicc支付结果 -->
    <pay-finish-cicc
      v-if="showFinish"
      :payResult="type"
      :failReason="reason"
      @rePay="rePay"
    />
  </div>
</template>
<script>
import api from "../../config/api.js";
import payFinishCicc from "./pay-finish-cicc.vue";
export default {
  name: "gopay",
  props: ["serData"],
  components: {
    payFinishCicc,
  },
  data: function () {
    return {
      comdata: this.serData[1] || [],
      type: "success",
      reason: "",
      showFinish: false,
      payUrl: "",
      taskId: "",
    };
  },
  created: function () {
    // window.closeIframePay = function () {
    //   window.history.go(-1)
    // }
    let vm = this;
    this.payUrl = window.payUrl;
    window.payUrl = "";
    this.taskId = setTimeout(vm.getCode, 5000);
    console.log("--------vm", vm);
  },
  methods: {
    closeIframePay() {
      window.history.go(-1);
      clearTimeout(this.taskId);
    },
    getCode: function () {
      let vm = this;
      let url = api.API_URL + "order/v1/get/status";
      if (vm.comdata.curType == 1)
        url = api.PAY_URL + "pay/queryPaymentDetailByCode";
      let paymentCode = localStorage.getItem("pCode");
      let data = {
        code: vm.comdata.curType == 1 ? paymentCode : vm.comdata.code,
      }; //获取code
      vm.getAjax(
        url,
        data,
        function (result) {
          if (vm.comdata.curType == 1) {
            let timeout = null;
            if (result.rcode !== "000000") {
              // 失败
              if (!timeout) {
                clearTimeout(timeout);
              }
              vm.showPop("fail", result.rdesc);
            } else {
              const { reason, status } = result.rdata;
              if (status === "SUCCESS") {
                // 成功
                if (!timeout) {
                  clearTimeout(timeout);
                }
                //
                vm.$emit("chanLayer", { cuindex: 3, menuIndex: 4, comBox: 0 }); //弹出框框
              } else if (status === "FAILURE") {
                // 支付失败
                if (!timeout) {
                  clearTimeout(timeout);
                }
                vm.showPop("fail", reason);
              } else if (status === "EXPIRE") {
                // 支付过期
                if (!timeout) {
                  clearTimeout(timeout);
                }
                vm.showPop("warning");
              } else {
                // 待支付 继续轮询
                timeout = setTimeout(vm.getCode, 5000);
                vm.taskId = timeout;
              }
            }
          } else {
            let timeout = null;
            if (result.rcode == "000000") {
              //如果支付成功
              if (result.rdata == "SUCCESS") {
                if (!timeout) {
                  clearTimeout(timeout);
                }
                //
                vm.$emit("chanLayer", { cuindex: 3, menuIndex: 4, comBox: 0 }); //弹出框框
              } else {
                timeout = setTimeout(vm.getCode, 5000);
                vm.taskId = timeout;
              }
            } else {
              if (!timeout) {
                clearTimeout(timeout);
              }
            }
            return;
          }
        },
        function () {}
      );
    },
    showPop: function (type, reason = "") {
      let vm = this;
      vm.type = type;
      vm.reason = reason;
      vm.showFinish = true;
    },
    rePay: function () {
      let vm = this;
      vm.showFinish = false;
      vm.bus.$emit("comBox", 0); // 关闭弹框
    },
  },
};
</script>
<style scoped="">
/*loding动画*/

.spinner {
  margin: 0 auto 0;
  width: 150px;
  text-align: center;
  margin-bottom: 10px;
}

.spinner > div {
  width: 12px;
  height: 12px;
  border-radius: 100%;
  display: inline-block;
  -webkit-animation: bouncedelay 1.4s infinite ease-in-out;
  animation: bouncedelay 1.4s infinite ease-in-out;
  /* Prevent first frame from flickering when animation starts */
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

.spinner .bounce1 {
  -webkit-animation-delay: -0.32s;
  animation-delay: -0.32s;
  /* background: rgba(255, 103, 123, 0.10); */
  background-color: #b39479;
}

.spinner .bounce2 {
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;
  /* background: rgba(255, 103, 123, 0.50); */
  background-color: #b39479;
}

.spinner .bounce3 {
  /* background: #FF677B; */
  background-color: #b39479;
}

@-webkit-keyframes bouncedelay {
  0%,
  80%,
  100% {
    -webkit-transform: scale(0);
  }
  40% {
    -webkit-transform: scale(1);
  }
}

@keyframes bouncedelay {
  0%,
  80%,
  100% {
    transform: scale(0);
    -webkit-transform: scale(0);
  }
  40% {
    transform: scale(1);
    -webkit-transform: scale(1);
  }
}
</style>
<style scoped>
.m-btn {
  font-size: 16px !important;
  color: #ffffff !important;
  background: #a28b77 !important;
  opacity: 0.3;
}
.m-btn:hover {
  font-size: 16px !important;
  color: #ffffff !important;
  background: #a28b77 !important;
  opacity: 0.3;
}
.pay-dialog-body {
  width: 531px;
  height: 90vh;
  background: #ffffff;
  border-radius: 8px;
  overflow: hidden;
}
.pay-dialog-top {
  position: relative;
  display: block;
  width: 100%;
  height: 66px;
  background: #1677ff;
}
.pay-dialog-top div {
  font-size: 20px;
  font-weight: 600;
  color: #ffffff;
  line-height: 64px;
  text-align: center;
}
.pay-dialog-top img {
  position: absolute;
  width: 18px;
  height: 18px;
  top: 16px;
  right: 20px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// go-pay.vue?9f47585e